import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Github, Linkedin, Instagram, Facebook, Mail } from 'lucide-react';
import styles from './Footer.module.css';
import logoImage from '../../images/main-logo.png';

const Footer = ({ mode, background }) => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };
  return (
    <footer id="contact" className={`${styles.footer} ${background === 'illustrations' ? styles.illustrationsFooter : ''} ${background === 'black' ? styles.blackFooter : ''}`}>
      <div className={styles.container}>
        <div className={styles.footerGrid}>
          <div className={styles.footerCol1}>
            <div className={styles.logoSection}>
              <img src={logoImage} alt="Logo" className={styles.footerLogo} />
            </div>
            <h3 className={styles.footerTitle}>Get In Touch</h3>
            <p className={styles.footerText}>Let's create something amazing together</p>
            <button className={styles.primaryBtn} onClick={handleContactClick}>Contact Me</button>
          </div>
          <div className={styles.footerCol2}></div>
          <div className={styles.footerCol3}></div>
          <div className={styles.footerCol4}>
            <h3 className={styles.footerTitle}>Follow Me</h3>
            <div className={styles.socialLinks}>
              <a href="https://www.linkedin.com/in/pavithra-chandran/" target="_blank" rel="noreferrer" className={styles.socialIcon}><Linkedin /></a>
              <a href="https://github.com/pavithra-chandran" target="_blank" rel="noreferrer" className={styles.socialIcon}><Github /></a>
              <a href="mailto:pavi.123.chandran@gmail.com" className={styles.socialIcon}><Mail /></a>
              <a href="https://www.instagram.com/pavithra____chandran/" target="_blank" rel="noreferrer" className={styles.socialIcon}><Instagram /></a>
              <a href="https://www.facebook.com/pavithra.chandran.75" target="_blank" rel="noreferrer" className={styles.socialIcon}><Facebook /></a>
            </div>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <p>&copy; 2026 Creative Portfolio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;